import React, { Component } from 'react';
import './generation_loader.css';
import Progressbar from './progress_bar'

class GenerationLoader extends Component {
    constructor(props) {
        super(props);
        this.state = {  };
    }
    render() {
        return (
            <div className="wrapper">
                <h1 className="title">Vos documents sont en cours de génération...</h1>
                
                    <Progressbar></Progressbar>
                
                <img className="generationLoader-image" src="/wizard/img/mes-locaux.svg" alt="description" />
                {/* <img src="../../../src/public/wizard/img/mes-locaux.svg"></img> */}
            </div>
        );
    }
}

export default GenerationLoader;


// WEBPACK FOOTER //
// ./src/components/generation_loader/generation_loader.js